// SIFEN Table 10; matches the XML generator's negotiation conditions.
export const INCOTERMS = [
  { code: "CFR", description: "Costo y flete" },
  { code: "CIF", description: "Costo, seguro y flete" },
  { code: "CIP", description: "Transporte y seguro pagados hasta" },
  { code: "CPT", description: "Transporte pagado hasta" },
  { code: "DAP", description: "Entregada en lugar convenido" },
  { code: "DAT", description: "Entregada en terminal" },
  { code: "DDP", description: "Entregada derechos pagados" },
  { code: "EXW", description: "En fábrica" },
  { code: "FAS", description: "Franco al costado del buque" },
  { code: "FCA", description: "Franco transportista" },
  { code: "FOB", description: "Franco a bordo" },
];
